import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Drawer,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useEffect, useState, Fragment } from "react";
import { useCookies } from "react-cookie";
import { TermAndCondition } from "@/components/common/term-and-condition/term_and_condition";
import InputCheckbox from "@/components/UI/input-checkbox/input_checkbox";
import Button from "@/components/UI/button/button";
import { useMediaQueries } from "@react-hook/media-query";
import style from "./consent_privacy_policy.module.css";

const CONSENT_COOKIE_NAME = "pdpa";
const CONSENT_COOKIE_LIFE_TIME = 24 * 60 * 60; // 1 days

export function ConsentPrivacyPolicy({
  clickSubmit,
  setClickSubmit,
  onSubmit,
}) {
  const [isConsentOpen, setIsConsentOpen] = useState(false);
  const [checked, setChecked] = useState(false);
  const [errorCheck, setErrorCheck] = useState(false);
  const [errorAgree, setErrorAgree] = useState(false);
  const [cookies, setCookies] = useCookies(["cookie-name"]);

  const mobile = useMediaQueries({
    screen: "screen",
    min: "(min-width: 0px)",
    max: "(max-width: 767px)",
  });

  const onAgree = () => {
    if (errorAgree) return;
    if (!checked) {
      setErrorCheck(true);
      return;
    }
    setCookies(CONSENT_COOKIE_NAME, true, {
      maxAge: CONSENT_COOKIE_LIFE_TIME,
      path: "/",
    });
    onSubmit();
  };

  const onCheck = (value) => {
    setChecked(value);
    if (value) setErrorCheck(false);
  };

  const closeModal = () => {
    setIsConsentOpen(false);
  };

  useEffect(() => {
    if (clickSubmit) {
      const consented = cookies[CONSENT_COOKIE_NAME];
      if (!consented || consented !== "true") {
        setIsConsentOpen(true);
      } else if (consented === "true") {
        onSubmit();
      }
    } else {
      setIsConsentOpen(false);
    }
  }, [clickSubmit]);

  const stickyComponent = (
    <Fragment>
      <InputCheckbox
        checked={false}
        error={errorCheck}
        defaultValue={false}
        parentClassName={style.consent_checkbox}
        onChange={() => onCheck(!checked)}
        text="ข้าพเจ้าผู้สมัคร/ผู้ใช้บริการได้อ่าน และเข้าใจข้อกำหนดและเงื่อนไข ดังกล่าวข้างต้นโดยตลอดแล้ว
        และตกลงให้ความยินยอมให้ บริษัท ทีคิวเอ็ม อินชัวร์รันส์ โบรคเกอร์ จำกัด
        และ บริษัท ทีคิวเอ็ม ไลฟ์ อินชัวร์รันส์ โบรคเกอร์ จำกัด
        เก็บรวบรวมใช้ และ/หรือเปิดเผยข้อมูลส่วนบุคคลของข้าพเจ้าภายใต้ข้อกำหนดและเงื่อนไขดังกล่าวข้างต้น"
        dataTestId="acceptPrivacy"
      />
      <Button
        text="ตกลง"
        enable={!errorAgree}
        onClick={onAgree}
        dataTestId="agreeConsentButton"
        parentClassName="w-full m-auto mt-4 tablet:max-w-[200px] block"
      />
    </Fragment>
  );

  return (
    <Fragment>
      {mobile.matchesAll ? (
        <Drawer
          PaperProps={{
            style: {
              height: "calc(100% - 64px)",
              top: 64,
              borderRadius: "0.75rem 0.75rem 0 0",
            },
          }}
          anchor="bottom"
          open={isConsentOpen}
          onClose={() => setClickSubmit(false)}
        >
          <TermAndCondition
            onClose={() => setClickSubmit(false)}
            setErrorAgree={setErrorAgree}
          />
          <div className={`${style.fixed_action_drawer}`}>
            {stickyComponent}
          </div>
        </Drawer>
      ) : (
        <Dialog
          open={isConsentOpen}
          sx={{
            "& .MuiDialog-container": {
              "& .MuiPaper-root": {
                width: "100%",
                maxWidth: "744px",
                borderRadius: "16px",
              },
            },
          }}
        >
          <DialogTitle
            sx={{
              padding: "16px",
              boxShadow: "0px 2px 12px 0px rgba(0, 10, 27, 0.07)",
              "@media (min-width: 768px)": {
                padding: "20px 24px",
              },
            }}
          >
            <div className="flex w-full justify-between items-center">
              <p className="text-lg tablet:text-xl font-bold">เอกสารขอความยินยอม</p>
              <IconButton
                sx={{ color: "#000A1B" }}
                aria-label="close"
                onClick={() => {
                  setClickSubmit(false);
                }}
              >
                <CloseIcon onClick={closeModal} />
              </IconButton>
            </div>
          </DialogTitle>
          <DialogContent sx={{ padding: 0 }}>
            <TermAndCondition
              isModal
              onClose={() => setClickSubmit(false)}
              setErrorAgree={setErrorAgree}
            />
          </DialogContent>
          <DialogActions
            sx={{
              padding: "20px 24px",
              boxShadow: "0px -2px 12px 0px rgba(0, 10, 27, 0.07)",
            }}
          >
            <div className="text-input2 bg-white">{stickyComponent}</div>
          </DialogActions>
        </Dialog>
      )}
    </Fragment>
  );
}
